<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Selejtezés jegyzőkönyvek</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/processes/declutters/reports/add')"
            icon="el-icon-plus"
            v-can="'declutterreport.create'"
          >
            Új selejtezés jegyzőkönyv
          </el-button>
        </div>
        <div v-loading="loading" style="min-height: 81px;">
          <table-filter
            v-if="filterConfig"
            :config="filterConfig"
            action="declutterReport/fetchAll"
          />
        </div>
        <declutter-report-list />
        <template v-if="$route.meta.showAddDeclutterReportDialog">
          <declutter-report-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateDeclutterReportDialog">
          <declutter-report-dialog
            :declutter-report-id="$route.params.id"
            type="update"
          />
        </template>
        <template v-if="$route.meta.showDeclutterReportViewDialog">
          <declutter-report-dialog
            :declutter-report-id="$route.params.id"
            type="view"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
  import DeclutterReportList from '../../../components/processes/declutters/reports/List';
  import DeclutterReportDialog from '../../../components/processes/declutters/reports/Dialog';
  import Sidebar from '../../../components/processes/declutters/Sidebar';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      DeclutterReportDialog,
      DeclutterReportList,
      TableFilter,
      Sidebar,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      this.setConfig();
      this.loading = false;
    },
    methods: {
      setConfig() {
        this.filterConfig = [
          {
            type: 'select',
            options: [
              {
                label: 'Rögzítve',
                status: 'recorded'
              },
              {
                label: 'Teljesítve',
                status: 'done'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
            defaultSearch: true,
          },
          {
            type: 'text',
            name: 'serialNumber',
            label: 'Sorszám',
            valueKEy: 'serialNumber',
          },
          {
            type: 'dateRange',
            name: 'deliveryDate',
            label: 'Kiállítás dátuma',
            valueKEy: 'deliveryDate',
          }
        ];
      },
    },
  };
</script>
